var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import { getDataFrameFromPois } from "../../utils/poi";
import "../icon/Icon.js";
let PoiTable = class PoiTable extends LitElement {
    constructor() {
        super(...arguments);
        this.pois = [];
        this.networkFields = [];
        this.selectedPoi = null;
        this.rowsPerPage = 15;
        this.dataFrame = getDataFrameFromPois(this.pois, this.networkFields);
    }
    updated(changedProperties) {
        if (changedProperties.has("pois") || changedProperties.has("networkFields")) {
            const newDataFrame = getDataFrameFromPois(this.pois, this.networkFields);
            if (JSON.stringify(this.dataFrame) !== JSON.stringify(newDataFrame)) {
                this.dataFrame = newDataFrame;
            }
        }
    }
    handleRowSelected(event) {
        const row = event.detail.selectedRows[0];
        if (!row) {
            this.selectedPoi = null;
            this.dispatchEvent(new CustomEvent("poi-selected", {
                detail: { poi: null }
            }));
            return;
        }
        // Find the POI from its ID or any unique field
        const poi = this.pois.find(p => p.poi_id === row.poi_id);
        this.selectedPoi = poi ?? null;
        // Optionally re-emit for parent components
        this.dispatchEvent(new CustomEvent("poi-selected", {
            detail: { poi: this.selectedPoi },
            bubbles: true,
            composed: true
        }));
    }
    handleRowDblClick(event) {
        const { row } = event.detail;
        if (!row) {
            return;
        }
        const poi = this.pois.find(p => p.poi_id === row.poi_id);
        if (poi) {
            this.dispatchEvent(new CustomEvent("poi-dblclick", {
                detail: { poi },
                bubbles: true,
                composed: true
            }));
        }
    }
    getErrors() {
        const errors = this.pois.filter(poi => poi.geocoder_accuracy && poi.geocoder_accuracy < 0.6);
        const incorrect = this.pois.filter(poi => poi.longitude && poi.latitude);
        return html `
            ${errors.length > 0 ? html `
                <p>${errors.length}</p>
                <basic-icon name="error" size="20" .label=${msg('POIs with low geocoding accuracy:', { id: 'poi.table.lowAccuracy', desc: 'Low accuracy POIs title' })} style="margin-right: 8px;"></basic-icon>
            ` : ''}
            ${incorrect.length < this.pois.length ? html `
                <p>${this.pois.length - incorrect.length}</p>
                <basic-icon name="incorrect" size="20" .label=${msg('POIs with missing or incorrect coordinates:', { id: 'poi.table.missingCoords', desc: 'Missing coordinates POIs title' })} style="margin-right: 8px;"></basic-icon>
            ` : ''}
        `;
    }
    render() {
        return html `<basic-table
            .dataFrame=${this.dataFrame}
            .rowsPerPage=${this.rowsPerPage}
            .selectedRowsIndex=${this.selectedPoi ? [this.selectedPoi.poi_id] : []}
            .selectType=${"single"}
            @rows-selected=${this.handleRowSelected}
            @row-dblclick=${this.handleRowDblClick}
        >
            <div class="infos" slot="table-actions">${this.getErrors()}</div>    
        </basic-table>`;
    }
};
PoiTable.styles = css `
        :host {
            display: block;
        }
        .infos {
            display: flex;
            align-items: center;
            gap: 4px;
        }
        p {
            margin: 0;
        }
    `;
__decorate([
    property({ type: Array })
], PoiTable.prototype, "pois", void 0);
__decorate([
    property({ type: Array })
], PoiTable.prototype, "networkFields", void 0);
__decorate([
    property({ type: Object })
], PoiTable.prototype, "selectedPoi", void 0);
__decorate([
    property({ type: Number })
], PoiTable.prototype, "rowsPerPage", void 0);
__decorate([
    state()
], PoiTable.prototype, "dataFrame", void 0);
PoiTable = __decorate([
    localized(),
    customElement("poi-table")
], PoiTable);
export { PoiTable };
//# sourceMappingURL=PoiTable.js.map